export default __webpack_public_path__ + "static/media/calendarIcon.c0fbf3fb.png";